import {uuid} from '../../../../components/utils/uuid';
import type {CharacterState, JournalEntry} from './character-state';

const JOURNAL_LIMIT = 200;

export type JournalRecord = Omit<JournalEntry, 'id' | 'time'>;

export const withJournalEntry = (state: CharacterState, record: JournalRecord): Partial<CharacterState> => ({
	journal: [...state.journal, {...record, id: uuid(), time: Date.now()}].slice(-JOURNAL_LIMIT),
});
